import Icon from "@/v2-ui/icon"

// The fixed tick as a section's legend draws it, inline with the text and
// in the same colour as the rows' LicenseFeatureGroupIncludedMark, so the
// legend's glyph is the one the reader then meets in the list.
function LicenseFeatureGroupLegendTick() {
  return (
    <span className="inline-flex size-3.5 items-center justify-center align-text-bottom text-primary">
      <Icon src="check" size={12} />
    </span>
  )
}

export default LicenseFeatureGroupLegendTick
